<div class="blog-img-wrap" *ngIf="categoryName !== null && categoryName !== undefined && categoryName !== ''">
  <span class="img-tag">
    {{ categoryName }}</span>
  <img
    href="['/blogs/'+(category.slug).replace(domain,'')]"
    [routerLink]="['/blogs/' + category.slug.replace(domain, '')]"
    src="{{
      category?.featured_media?.media_details?.sizes?.medium?.source_url
    }}"
    styleClass="thumb-img "
    class="cursor thumb-img"
    alt="{{ category.title.rendered }}"
  />
</div>
